var _path, _path2, _path3, _path4, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCategoryMath(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6006 2C39.1237 2 47.6542 10.5306 47.6543 21.0537C47.6543 26.7517 45.1518 31.8638 41.1875 35.3555C39.2858 37.6381 36.9549 41.2081 36.7988 45.9619H20.2227C20.0417 40.4474 16.9334 36.526 14.9639 34.3594C11.6127 30.9253 9.54688 26.231 9.54688 21.0537C9.54693 10.5307 18.0775 2.00005 28.6006 2Z",
    fill: "#FFCF24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.5073 7.34389C11.8808 11.5638 12.198 16.48 13.0599 18.4106C15.8524 22.2891 19.731 20.8412 27.4364 18.1004C35.1419 15.3595 36.0727 9.25724 34.0042 5.94753C31.9356 2.63782 24.5404 2.06896 17.5073 7.34389Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M42.8587 27.5589C44.547 25.408 43.9332 23.5937 43.4153 22.9555C41.9764 21.78 40.6655 22.7139 38.0477 24.5186C35.4298 26.3232 35.6943 28.7085 36.8042 29.7432C37.914 30.778 40.7484 30.2475 42.8587 27.5589Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.609 46.2249L23.17 34.8504C22.9253 33.7089 24.4783 33.1165 25.0559 34.1311C25.5202 34.9466 26.7462 34.7566 26.9419 33.8388L27.7184 30.1979C27.9438 29.1408 29.4658 29.1809 29.6352 30.2484L30.1435 33.4512C30.3126 34.5166 31.7038 34.8166 32.2968 33.9155C33.0219 32.8137 34.7334 33.5486 34.4339 34.833L31.7776 46.2249",
    stroke: "white",
    strokeWidth: 2.73432
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.1914,
    y: 44.5269,
    width: 18.8174,
    height: 8.47321,
    rx: 2.73432,
    fill: "#F46D0C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryMath);
export default __webpack_public_path__ + "static/media/category_math.111553384bc3ad96dd7fb0f5f803866a.svg";
export { ForwardRef as ReactComponent };